/**
 * 权限定义
 */
const ACCESS_ENUM = {
    NOT_LOGIN: "未登录",
    USER: "普通用户",
    VIP: "普通会员",
    VIP_GOLD: "黄金会员",
}
export default ACCESS_ENUM
